/** @format */

//importing assets
import { useState } from "react";

//import componets
import HeadTitle from "../global/HeadTitle";

//importing Assets
import Pic from "../../Assets/images/ahmedEldesoky.png";
import BlockIcon from "../../Assets/icons/blockicon.svg";
import RightIcon from "../../Assets/icons/right-icon.svg";
import GreenIcon from "../../Assets/icons/green-radio.svg";
import RedIcon from "../../Assets/icons/red-radio.svg";
import { useSelector } from "react-redux";

export const UserCard = ({ block }) => {
  const client = useSelector((state) => state.clientSlice.client);

  return (
    <div className='user-card'>
      <div className='user-card__side-right'>
        <div
          className='user-card__img-box'
          style={
            block
              ? { backgroundColor: "#DA0000" }
              : { backgroundColor: "#0C9700" }
          }>
          <img
            src={block ? BlockIcon : RightIcon}
            alt='block '
            className='user-card__icon'
          />
          <img
            src={client.image}
            alt='profile-pic'
            className='user-card__img'
          />
        </div>
        <div className='col-flex'>
          <h2 className='ternary__heading--mid '> {client.name}</h2>
          <h2 className='ternary__heading--mid text--primary'>كفيل </h2>

          {!block && (
            <div className='display-flex'>
              <img src={GreenIcon} alt='radio icon' />
              <h2 className='ternary__heading--mid text--green'>
                مـــوثــــق{" "}
              </h2>
            </div>
          )}
          {block && (
            <div className='display-flex'>
              <img src={RedIcon} alt='radio icon' />
              <h2 className='ternary__heading--mid text--red'>محظـور </h2>
            </div>
          )}
        </div>
      </div>
      <div className='user-card__side-left'>
        <h2 className='ternary__heading--mid '>
          {" "}
          <h2 className='ternary__heading--mid '> الرصيد الكلي</h2>
        </h2>
        <h2 className='ternary__heading--mid '>
          {" "}
          <h2 className='ternary__heading--mid '>{client.balance} د.ك </h2>
        </h2>
      </div>
    </div>
  );
};
